import { types } from "../actions";
import { filterCriticalEvents } from "../../model/eventService";
import { RESOLVE_STATUS } from "../../global/constants/constants";

const initialState = {
  loadingEvents: true,
  allEvents: [],
  criticalEvents: [],
  cameraEventMap: {},
  criticalUnresolved: [],
  criticalEventsCount: 0,
  sourceId: "",
  eventError: false,
  expandedEvent: {},
  incidentsByFloor: {
    data: {},
    loading: false,
    error: null,
  },
  resolveStatus: {
    status: RESOLVE_STATUS.IDLE, // idle | checking | in_progress | complete | error
    loading: false,
    error: null,
  },
  pageSize: 0,
  isCriticalEventsFetching: false,
  hasFetchedCriticalEventsOnce: false,
};

const eventReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCHED_EVENTS: {
      const cricEvents = filterCriticalEvents(action.eventData);

      return {
        ...state,
        allEvents: action.eventData,
        criticalEvents: cricEvents,
        cameraEventMap: action.ceMap,
      };
    }

    case types.APPEND_EVENT_SUCCESS:
      const allCricEvents = [action.eventData, ...state.criticalUnresolved];
      const cricEvents = filterCriticalEvents(allCricEvents);

      return {
        ...state,
        criticalUnresolved: cricEvents
      };

    case types.SET_SOURCE_ID: {
      return {
        ...state,
        sourceId: action.id,
        evidence: action.evidence,
      };
    }
    case types.EVENT_ERROR: {
      return {
        ...state,
        eventError: action.value,
      };
    }
    case types.LOADING_EVENTS: {
      return {
        ...state,
        loadingEvents: action.value,
      };
    }

    case types.FETCH_CRITICAL_UNRESOLVED_EVENTS_REQUEST:
      return { ...state, isCriticalEventsFetching: true };

    case types.FETCH_CRITICAL_UNRESOLVED_EVENTS_SUCCESS:
      return {
        ...state,
        isCriticalEventsFetching: false,
        criticalUnresolved: action.payload.events,
        criticalEventsCount: action.payload.count,
        pageSize: Math.ceil(action.payload.XTotalCount / 10),
        hasFetchedCriticalEventsOnce: true,
      };

    case types.FETCH_CRITICAL_UNRESOLVED_EVENTS_FAILURE:
      return { ...state, isCriticalEventsFetching: false };

    case types.SAVE_EXPANDED_EVENT:
      return {
        ...state,
        expandedEvent: action.value
      };

    case types.CLEAR_EXPANDED_EVENT:
      return {
        ...state,
        expandedEvent: {}
      };

    case types.FETCH_INCIDENTS_BY_FLOOR_REQUEST:
      return {
        ...state,
        incidentsByFloor: {
          ...state.incidentsByFloor,
          loading: true,
          error: null,
        },
      };

    case types.FETCH_INCIDENTS_BY_FLOOR_SUCCESS:
      return {
        ...state,
        incidentsByFloor: {
          data: action.payload,
          loading: false,
          error: null,
        },
      };

    case types.FETCH_INCIDENTS_BY_FLOOR_FAILURE:
      return {
        ...state,
        incidentsByFloor: {
          ...state.incidentsByFloor,
          loading: false,
          error: action.payload,
        },
      };

    case types.CHECK_RESOLVE_STATUS_REQUEST:
      return {
        ...state,
        resolveStatus: {
          ...state.resolveStatus,
          loading: true,
          error: null,
        },
      };

    case types.CHECK_RESOLVE_STATUS_SUCCESS:
      return {
        ...state,
        resolveStatus: {
          status: action.payload.status || RESOLVE_STATUS.IDLE,
          loading: false,
          error: null,
        },
      };

    case types.CHECK_RESOLVE_STATUS_FAILURE:
      return {
        ...state,
        resolveStatus: {
          ...state.resolveStatus,
          loading: false,
          error: action.payload,
          status: RESOLVE_STATUS.ERROR,
        },
      };

    case types.STOP_RESOLVE_STATUS_POLLING:
      return {
        ...state,
        resolveStatus: {
          ...initialState.resolveStatus,
          status: RESOLVE_STATUS.IDLE,
        },
      };

    default:
      return state;
  }
};
export default eventReducer;
